export default __webpack_public_path__ + "static/media/smart-meter.b377e081.svg";